<div class="holder">
  <div class="month-cost">
    <div class="title">Månadskostnad:</div>
    <div class="amount">
      @if (hemnetService.valid()) {
        {{ monthlyCost() | number: '1.0-0' : 'fr' }} kr
      } @else {
        -
      }
    </div>
  </div>
  <div class="loan-amount">
    <div class="title">Lånebelopp:</div>
    <div class="amount">
      @if (hemnetService.valid()) {
        {{ loanAmount() | number: '1.0-0' : 'fr' }} kr
      } @else {
        -
      }
    </div>
  </div>
  <div class="details">
    <div class="title">Så här har vi räknat:</div>
    <spb-item [value]="monthlyInterest()" label="Ränta"/>

    <spb-item [value]="amortization()" label="Amortering"/>

    @if (runCost()) {
      <spb-item [value]="runCost()" label="Driftskostnad"/>
    }
    @if (fee()) {
      <spb-item [value]="fee()" label="Månadsavgift"/>
    }
    <spb-item [value]="monthlyTaxReduction() * -1" label="Skattereduktion"/>
    <spb-item [value]="monthlyCost()" label="Totalt"/>
  </div>
</div>
